import { LucideLoaderCircle } from "lucide-react";
import React from "react";

export const LazyImage = (
  props: React.ImgHTMLAttributes<HTMLImageElement> & {
    width: number;
    height: number;
  },
) => {
  const [loaded, setLoaded] = React.useState(false);
  return (
    <span className="relative inline-block">
      {loaded ? null : (
        <span
          style={{
            width: `${props.width}px`,
            height: `${props.height}px`,
            display: "inline-block",
          }}
        >
          <LucideLoaderCircle className="text-primary h-full w-full animate-spin" />
        </span>
      )}
      <img
        {...props}
        onLoad={() => setLoaded(true)}
        className={loaded ? "" : "absolute"}
      ></img>
    </span>
  );
};
